module.exports = __webpack_public_path__ + "img/useManual.3bb6bdaf.gif";